import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { TabShape } from '@/components/Tabs/Tabs.types';

export const Box = styled.div<{ $shape: TabShape; $hasTopPadding?: boolean }>`
  display: flex;
  align-items: center;
  padding: ${({ $hasTopPadding }) => ($hasTopPadding ? '15px' : '0 15px 15px')};
  overflow-y: auto;

  ${({ $shape }) =>
    $shape === 'rounded'
      ? css`
          gap: 10px;
        `
      : css`
          justify-content: space-between;
        `}
`;

export const Tab = styled(Button)<{
  $isFirst: boolean;
  $isLast: boolean;
  $isActive?: boolean;
  $shape: TabShape;
}>`
  color: ${({ theme }) => theme.palette.secondary.labels};
  border-radius: 0;
  height: 37px;
  overflow: hidden;
  padding: 0 15px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  border-right-width: 0;
  min-width: min-content;
  white-space: nowrap;

  ${({ $shape, $isFirst, $isLast }) =>
    $shape === 'rounded'
      ? css`
          border-radius: 20px;
          background-color: ${({ theme }) =>
            theme.palette.secondary.background};
          border: 0;
        `
      : css`
          flex-grow: 1;

          ${() =>
            $isFirst &&
            css`
              border-top-left-radius: 7px;
              border-bottom-left-radius: 7px;
            `}

          ${() =>
            $isLast &&
            css`
              border-top-right-radius: 7px;
              border-bottom-right-radius: 7px;
              border-right-width: 1px;
            `}
        `}
  ${({ $isActive }) =>
    $isActive &&
    css`
      color: ${({ theme }) => theme.palette.system.white};
      border-color: ${({ theme }) => theme.palette.brand.main};
      background-color: ${({ theme }) => theme.palette.brand.main};
    `};
`;
